import { Injectable } from '@angular/core';
import { ILocalStorage } from '@models/localStorage';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {}

  public storeInLocalStorage<T>(data: any, type: string, productId?: number) {
    // Step One we create the key
    const key = `${type}${productId || ''}`;

    // Create the storage object
    const storageObject: ILocalStorage<T> = {
      storeDate: new Date().toISOString(),
      productId,
      payload: data
    };
    // Store this item in the local storage
    localStorage.setItem(key, JSON.stringify(storageObject));
  }

  public fetchFromLocalStorage<T>(type: string, id?: number): ILocalStorage<T> {
    const key = `${type}${id || ''}`;
    const localStorageItemAsString = localStorage.getItem(key);
    if (localStorageItemAsString) {
      try {
        return JSON.parse(localStorageItemAsString) as ILocalStorage<T>;
      } catch (error) {
        console.error(error);
        // If we have an error parsing we are going to clear the local storage
        this.clearFromLocalStorage(type, id);
        return null;
      }
    } else {
      return null;
    }
  }

  /**
   * Removes one item from the local storage based on product ID and type
   */
  public clearFromLocalStorage(type: string, productId?: number): void {
    const key = `${type}${productId || ''}`;
    localStorage.removeItem(key);
  }
}
